import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Redirect, useParams } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import MailOutline from "@material-ui/icons/MailOutline";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";

import View from "./View";

import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";

import { bookingApi } from "functions/apis";

const useStyles = makeStyles(styles);

export default function SetAsCheckInResolved(props) {
  const source = useRef(new AbortController());

  useEffect(() => {
    return () => source.current.abort();
  }, []);
  const { id } = useParams();
  const [coreApiCheckIn, setCoreApiCheckIn] = React.useState(null);
  const [redirect, setRedirect] = React.useState(false);
  useEffect(() => {
    bookingApi
      .get("/CoreApiCheckIns/" + id, {
        signal: source.current.signal
      })
      .then(data => setCoreApiCheckIn(data))
      .catch(error => console.log(error));
  }, [id]);

  const [disabled, setDisabled] = React.useState(false);
  const [boardingPassNo, setBoardingPassNo] = React.useState(null);

  const handleBoardingPassNoChanged = e => setBoardingPassNo(e.target.value);

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);
    bookingApi
      .post(
        "/CoreApiCheckins/SetAsCheckInResolved",
        {
          id: id,
          boardingPassNo: boardingPassNo
        },
        {
          signal: source.current.signal
        }
      )
      .then(() => setRedirect(true))
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  };

  const classes = useStyles();
  return redirect ? (
    <Redirect to="/admin/CoreApiCheckIns/CheckInError" />
  ) : (
    coreApiCheckIn !== null && (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <MailOutline />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                Set As Check-In RESOLVED
              </h4>
            </CardHeader>
            <CardBody>
              <i>
                *Please review the Check-In Information before Set As Resolved.
                Once it is Resolved, it cannot be reverted and you cannot retry
                Check-In Process.
              </i>
              <form onSubmit={handleSubmit}>
                <CustomInput
                  disabled
                  labelText="BP No"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: handleBoardingPassNoChanged,
                    value: boardingPassNo ?? ""
                  }}
                />
                <Button onClick={() => props.history.goBack()} value="Cancel">
                  Cancel
                </Button>
                <Button
                  disabled={disabled}
                  color="rose"
                  type="submit"
                  value="Submit"
                >
                  SET AS RESOLVED
                </Button>
              </form>
              <View coreApiCheckIn={coreApiCheckIn} />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    )
  );
}

SetAsCheckInResolved.propTypes = {
  history: PropTypes.object
};
